import {
    archizeenTileClassName,
    pxToRem,
    SubheaderClassName,
    flexClassName,
    captionClassName,
    paginationItemClassName,
    tileImageClassName,
    tileImageSlotClassNames,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';

export const ArticleSection: StyleRule = ({ theme }) => ({
    [`& .${archizeenTileClassName} .${SubheaderClassName}`]: {
        paddingRight: pxToRem(4),
        ...theme.siteVariables.textStyles.Article.Roman55,
    },

    [theme.screen.laptop]: {
        paddingTop: 0,
        paddingBottom: pxToRem(40),

        [`& .${archizeenTileClassName} .${SubheaderClassName}`]: {
            paddingRight: 0,
        },
    },

    [theme.screen.clamped]: {
        [`& .${archizeenTileClassName}`]: {
            width: '100%',
            [`& .${tileImageClassName}`]: {
                width: '100%',
                [`& > div`]: {
                    width: '100%',
                },
            },
            [`& .${tileImageSlotClassNames.imageContainer}`]: {
                width: '100%',
            },
        },
    },
});

export const ArticleGrid: StyleRule = ({ theme }) => ({
    gridGap: `${theme.siteVariables.spaces['space-24']} 0`,
    paddingTop: 0,
    paddingBottom: pxToRem(40),
});

export const ArticleGridMobile: StyleRule = ({ filmsLayout }) => ({
    gap: filmsLayout ? pxToRem(60) : 0,

    [`& .${archizeenTileClassName}`]: {
        borderBottom: `1px solid rgba(52, 52, 52, 0.2)`,

        [`& > .${flexClassName} > .${flexClassName}`]: {
            margin: pxArrayToRem([0, 4, 8, 0]),

            [`& .${captionClassName}`]: {
                minHeight: pxToRem(13),
            },

            [`& > .${flexClassName}`]: {
                margin: pxArrayToRem([2, 0, 0, 0]),
            },
        },
    },
});

export const Header: StyleRule = ({ theme }) => ({
    [`& > div`]: {
        padding: pxArrayToRem([0, 18]),
    },
    [theme.screen.laptop]: {
        [`& > div`]: {
            padding: pxArrayToRem([0, 36]),
        },
    },

    [theme.screen.clamped]: {
        [`& > div`]: {
            padding: 0,
        },
    },
});
export const Container: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        padding: pxArrayToRem([0, 36]),
    },

    [theme.screen.clamped]: {
        padding: 0,
        margin: pxArrayToRem([0, -14]),
    },
});

export const PaginationWrapper: StyleRule = ({ theme }) => ({
    marginTop: pxToRem(50),

    padding: pxArrayToRem([0, 18]),
    width: '100%',
    [theme.screen.laptop]: {
        marginTop: pxToRem(120),
        padding: 0,
        width: 'unset',
    },

    [`& .ui-dropdown__trigger-button`]: {
        outline: 'none',
    },
});

export const PaginationMobile: StyleRule = () => ({
    width: '100%',

    [`& .${paginationItemClassName}`]: {
        display: 'flex',
    },
});

export const EmptySpaceAboveTiles: StyleRule = () => ({
    height: pxToRem(150),
    borderTop: `1px solid rgba(52, 52, 52, 0.2)`,
});
